import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Seguro} from '../../../_models/seguro';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {ListaItem} from '../../../_models/lista-item';
import {ProductoDestino} from '../../../_models/producto-destino';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../../_services/_nav.service';
import {ListaService} from '../../../_services/lista.service';
import {forkJoin} from 'rxjs';
import {Control} from '../../../_models/control';
import {FileUpload} from 'primeng/fileupload';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {AppSettings} from '../../../../proyect.conf';
import {AdjuntoService} from '../../../_services/adjunto.service';
import {SeguroCobertura} from '../../../_models/seguro-cobertura';
import {SeguroPlanService} from '../../../_services/seguro-plan.service';
import {SeguroCoberturaService} from '../../../_services/seguro-cobertura.service';
import {Estado} from '../../../_models/estado';
import {Location} from '@angular/common';
import {PoliticaModalidad} from '../../../_models/politica-modalidad';
import {PoliticaPlanteamientoPolitica} from '../../../_models/politica-planteamiento-politica';
import { QuillEditorComponent } from 'ngx-quill';
import {ConstanteService} from "../../../_services/constante.service";
import {Constantes} from "../../../_enums/enum";

@Component({
  selector: 'app-seguros-coberturas',
  templateUrl: './seguros-coberturas.component.html',
  styleUrls: ['./seguros-coberturas.component.css']
})
export class SegurosCoberturasComponent implements OnInit {

  @Input() seguro: Seguro;

  lisCoberturas: SelectItem[] = [];
  lisCoberturasTodos: ListaItem[] = [];
  carInformacionInicial = true;
  lisSegurosCoberturas: SeguroCobertura[] = [];
  lisSegurosCoberturasTodos: SeguroCobertura[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];

  imagen: SafeResourceUrl;
  svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  dataUploadArchivo: any = '';
  dataUploadUsuario: any = '';
  usuarioLogueado: any;
  @ViewChild( 'adjunto' ) adjunto: FileUpload;
  fsize: number;
  ftype = 'image/svg+xml';
  subAdjunto = false;
  carTabla = true;

  constructor(private navServicio: NavService,
              private fb: FormBuilder,
              private lisServicio: ListaService,
              private autServicio: AutenticacionService,
              private adjServicio: AdjuntoService,
              private serSeguroCobertuta: SeguroCoberturaService,
              private conServicio: ConfirmationService,
              private location: Location,
              private authService: AutenticacionService,
              private sanitizer: DomSanitizer,
              private constanteService: ConstanteService) { }

  ngOnInit() {

    this.columnas = [
      { field: 'nombreCobertura', header: this.navServicio.buscarMensaje( 'SEGUROCOBERTURAS.LBL_COBERTURAS' ), sort: false },
      { field: 'nombreCoberturaBilletera', header: this.navServicio.buscarMensaje( 'SEGUROCOBERTURAS.LBL_COBERTURABILLETERA' ), sort: false },
      { field: 'icono', header: this.navServicio.buscarMensaje( 'SEGUROCOBERTURAS.LBL_ICONO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.usuarioLogueado = this.autServicio.obtenerUsuario();

    forkJoin(
      this.lisServicio.getMasterDetails( 'ListasCoberturasSeguros' ),
      this.serSeguroCobertuta.listadoPorIdSeguro(this.seguro.idSeguro),
      this.constanteService.getByCode(Constantes.FSIZE)).subscribe( async ( [  lisCobertura, lisSegurosCoberturas, fSize ] ) => {

      this.lisCoberturasTodos = lisCobertura;
      this.lisSegurosCoberturasTodos = lisSegurosCoberturas;
      this.fsize = Number(fSize.valor);

      await Promise.all( lisSegurosCoberturas.map( async( s: SeguroCobertura ) => {
        if ( s.indicadorHabilitado) {
          if (s.idIconoAdjunto ) {
            this.cargarlogo(s);
          }
          this.lisSegurosCoberturas.push(s);
        }
      } ) );
      this.cargarFormulario();
      this.cargarListadoEstados();
      this.carInformacionInicial = false;
    } );
  }


  cargarListadoEstados() {
    this.lisCoberturas = [];
    this.lisCoberturasTodos.map( ( s: ListaItem ) => {
      if (  !this.lisSegurosCoberturas.find( x => x.idListaCobertura === s.idLista ) ) {
        this.lisCoberturas.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }





  cargarFormulario() {
    this.formulario = this.fb.group( {
      idSeguroCobertura: [ null ],
      idSeguros: [ this.seguro.idSeguro, [ Validators.required ] ],
      idListaCobertura: [ null, [ Validators.required ] ],
      nombreAdjuntoIcono: [ null ],
      indicadorHabilitado: [ true ],
      idIcono: [ null, [ Validators.required ] ],
      auditoriaUsuario: [ null ],
      auditoriaFecha: [ null ],
      nombreArchivo: [ null ],
      nombreCoberturaBilletera: [ null ],
    } );
    this.imagen = null;
  }

  get f() {
    return this.formulario.controls;
  }


  onBeforeSend( event: any ) {
    this.subAdjunto = true;
    this.adjServicio.cargarArchivo( event, this.dataUploadArchivo, '/Crezcamos/Producto/Referencias' );
  }

  onSelect( event: any, file: any ) {
    if (this.adjunto.msgs.length === 0) {
      this.dataUploadArchivo = file[ 0 ].name;
      this.dataUploadUsuario = this.usuarioLogueado.idUsuario;
      this.f.nombreAdjuntoIcono.setValue( file[ 0 ].name );
      this.f.nombreArchivo.setValue( file[ 0 ].name );
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
      }, false );
      if ( file[ 0 ] ) {
        reader.readAsDataURL( file[ 0 ] );
      }
    } else {
      this.navServicio.setMesageArray( this.adjunto.msgs );
    }

  }



  uploadingOk( event: any ) {
    const respuesta = event.originalEvent.body
    if ( respuesta.idAdjunto != null || respuesta.idAdjunto !== undefined ) {
      this.f.idIcono.setValue( respuesta.idAdjunto );
      this.cargarlogoInicial(respuesta.idAdjunto);
      this.subAdjunto = false;
    }
  }


  eliminarAdjunto() {
    this.f.idIcono.setValue(null);
    this.f.nombreArchivo.setValue(null);
  }

  cargarlogoInicial(idAdjunto) {
    this.subAdjunto = true;
    this.adjServicio.descargarArchivo( idAdjunto ).subscribe( adjunto => {
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
      }, false );
      if ( adjunto ) {
        reader.readAsDataURL( adjunto );
      }
      this.subAdjunto = false;
    });
  }


  async cargarlogo(s: SeguroCobertura) {

    const adjunto = await this.adjServicio.descargarArchivo( s.idIconoAdjunto ).toPromise();
    const reader = new FileReader();
    reader.addEventListener( 'load', () => {
      s.imagen = this.sanitizer.bypassSecurityTrustUrl(reader.result.toString());
    }, false );
    if ( adjunto ) {
      reader.readAsDataURL( adjunto );
    }
  }

  async onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid) {

      this.carInformacionInicial = true;
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      const temp = {} as SeguroCobertura;
      temp.idSeguro = this.seguro.idSeguro;
      temp.idIconoAdjunto = formulario.idIcono;
      temp.idListaCobertura = formulario.idListaCobertura;
      temp.nombreCoberturaBilletera = formulario.nombreCoberturaBilletera;
      temp.indicadorHabilitado = true;
      temp.auditoriaUsuario = this.usuarioLogueado.idUsuario;
      const existe = this.lisSegurosCoberturasTodos.find( x => x.idListaCobertura === formulario.idListaCobertura);
      if (existe) {
        temp.idSeguroCobertura = existe.idSeguroCobertura;
      }
      const existeCodigo = this.lisCoberturasTodos.find( x => x.idLista === formulario.idListaCobertura);
      temp.codigoCobertura = existeCodigo != null ? existeCodigo.codigo : null;
      temp.nombreCobertura = existeCodigo != null ? existeCodigo.nombre : null;
      const tempGuardar = await this.serSeguroCobertuta.crear(temp).toPromise();
      temp.idSeguroCobertura = tempGuardar.idSeguroCobertura;
      this.cargarlogo(tempGuardar);
      tempGuardar.codigoCobertura = existeCodigo != null ? existeCodigo.codigo : null;
      tempGuardar.nombreCobertura = existeCodigo != null ? existeCodigo.nombre : null;
      this.lisSegurosCoberturas.push(tempGuardar);
      this.cargarListadoEstados();
      this.carInformacionInicial = false;
      this.submitted = false;
      this.guardando = false;
      this.f.idIcono.setValue(null);
      this.f.nombreArchivo.setValue(null);
      this.f.idListaCobertura.setValue(null);
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'plan',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

   eliminarSegurosCoberturas(s: SeguroCobertura, posicion: number) {
    this.conServicio.confirm({
      header: this.navServicio.buscarMensaje('LBL_INFORMACION'),
      message: this.navServicio.buscarMensaje('SEGUROCOBERTURAS.MSG_ELIMINARCAMBIOS'),
      key: 'eliminar',
      accept: async () => {
        s.indicadorHabilitado = false;
        await this.serSeguroCobertuta.actualizar(s).toPromise();
        const posicionRe = this.lisSegurosCoberturas.findIndex(
          x => x.idSeguroCobertura === s.idSeguroCobertura);
        if (posicionRe >= 0) {
          this.lisSegurosCoberturas.splice(posicionRe, 1);
        }
        this.cargarListadoEstados();
      },
      reject: () => {
      }
    });
  }

}
